import { render, staticRenderFns } from "./AdxDetail.vue?vue&type=template&id=72dec6ba"
import script from "./AdxDetail.vue?vue&type=script&lang=js"
export * from "./AdxDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports